import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const FlagEditarVentasFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagEditarVentas'>
      {({ field }) => (
        <Form.Checkbox
          {...field}
          checked={iValue}
          disabled={fIsSubmitting}
          id='checkbox-flagEditarVentas'
          label='Editar ventas'
        />
      )}
    </Field>
  )
}

export default React.memo(FlagEditarVentasFormGroup)
